
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { IfComp } from '../../../core';

const ObjectDetailAttributeGeneric = ({attribute, dataModel, value, valueComponent}) => {

    const classNames = mergeStyleSets({
        ObjectAttribute: {
        },
        name: {
            width: 150,
            color: '#999999',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
        },
        valueContainer: {
            width: 150,
        }
    });

    return (
        <IfComp cond={value}>
            <Stack horizontal className={classNames.ObjectAttribute} tokens={{childrenGap: 4}}>
                <Stack.Item className={classNames.name}>
                    <div title={attribute.title}>{attribute.title}:</div>
                </Stack.Item>
                <Stack.Item className={classNames.valueContainer}>
                    {valueComponent}
                </Stack.Item>
            </Stack>
        </IfComp>
    );
}

export default ObjectDetailAttributeGeneric;
